import React from 'react';
import FilterGroup, { FilterItem } from './FilterGroup';
import { Wrapper } from './EventFilter.styles';

interface EventFilterProps {
  mcClubs: FilterItem[];
  counties: FilterItem[];
  selectedMcClubs: string[];
  selectedCounties: string[];
  onMcClubsChange: (next: string[]) => void;
  onCountiesChange: (next: string[]) => void;
}

const EventFilter = ({
  mcClubs,
  counties,
  selectedMcClubs,
  selectedCounties,
  onMcClubsChange,
  onCountiesChange,
}: EventFilterProps) => (
  <Wrapper>
    <FilterGroup header="NAF MC Klubb" items={mcClubs} selected={selectedMcClubs} onChange={onMcClubsChange} />
    <FilterGroup header="Lokalavdeling" items={counties} selected={selectedCounties} onChange={onCountiesChange} />
  </Wrapper>
);

export default EventFilter;
